// Route path constants
export const ROUTE_PATHS = {
  // Auth routes
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
  CHANGE_PASSWORD: '/change-password',
  EDIT_PROFILE: '/edit-profile',
  CONFIGURATION: '/configuration',
  CONFIGURATION_ADD: '/configuration/add',

  // Dashboard
  DASHBOARD: '/',

  // Daily roster
  DAILY_ROSTER: '/daily-roster',
  ADD_LESSON: '/daily-roster/add-lesson',
  INSTRUCTOR_ROSTER_LIST: '/daily-roster/instructor',

  // Transport
  TRANSPORT_ROSTER: '/transport-roster',

  // Lesson entry
  LESSON_ENTRY: '/lesson-entry',

  // Report manager routes
  REPORT_MANAGER_INSTRUCTOR_REPORT: '/report-manager/instructor-report',
  REPORT_MANAGER_FINANCIAL_REPORT: '/report-manager/financial-report',
  REPORT_MANAGER_HOTEL_AGENTS_REPORT: '/report-manager/hotel-agents-report',
  REPORT_MANAGER_MOUNTAIN_PARTICIPANT_PARTY:
    '/report-manager/mountain-participant-party',
  REPORT_MANAGER_MOUNTAIN_FINANCIAL_REPORT:
    '/report-manager/mountain-financial-report',
  REPORT_MANAGER_GROUP_LESSON_REPORT: '/report-manager/group-lesson-report',
  REPORT_MANAGER_TRANSPORT_PAX_REPORT: '/report-manager/transport-pax-report',
  // Hotel agent manager routes
  HOTEL_AGENT_MANAGER_ALL: '/hotel-agent-manager',
  HOTEL_AGENT_MANAGER_ADD: '/hotel-agent-manager/add',
  HOTEL_AGENT_MANAGER_COMMISSION_RATE: '/hotel-agent-manager/commission-rate',

  // Booking manager routes
  BOOKING_MANAGER_ALL_BOOKINGS: '/booking-manager',
  BOOKING_MANAGER_BOOKING_USERS: '/booking-manager/booking-users',
  BOOKING_MANAGER_BOOKING_USERS_LIST: '/booking-manager/booking-users-list',
  BOOKING_MANAGER_BROADCAST_MANAGER: '/booking-manager/broadcast-manager',
  BOOKING_MANAGER_DETAILS: '/booking-manager/booking-details',

  // Instructor manager routes
  INSTRUCTOR_MANAGER_LIST: '/instructor-manager',
  INSTRUCTOR_MANAGER_ADD: '/instructor-manager/add',
  INSTRUCTOR_MANAGER_PAY_RATE: '/instructor-manager/pay-rate',

  // Staff manager routes
  STAFF_MANAGER_LIST: '/staff-manager',
  STAFF_MANAGER_ADD: '/staff-manager/add',
  STAFF_MANAGER_REPORT: '/report-manager/staff-report',

  // Service manager routes
  SERVICE_MANAGER_ALL: '/service-manager',
  SERVICE_MANAGER_ADD: '/service-manager/add',

  // Mountain manager routes
  MOUNTAIN_MANAGER_ALL: '/mountain-manager',
  MOUNTAIN_MANAGER_ADD: '/mountain-manager/add',

  // Transport manager routes
  TRANSPORT_MANAGER_ALL: '/transport-manager',
  TRANSPORT_MANAGER_ADD: '/transport-manager/add',

  // Admin users manager routes
  ADMIN_USERS_MANAGER_ADD: '/admin-users-manager/add',
  ADMIN_USERS_MANAGER_LIST: '/admin-users-manager',

  // Other routes
  CHEAT_SHEET_LIST: '/cheat-sheet-list',

  // Diet manager routes
  DIET_MANAGER_LIST: '/diet-manager/list',
  DIET_MANAGER_ADD: '/diet-manager/add',

  // Participants list routes
  PARTICIPANTS_LIST: '/participants-list'
} as const;

// Routes where the sidebar should be collapsed by default
export const COLLAPSE_SIDEBAR_ROUTES: string[] = [
  ROUTE_PATHS.DAILY_ROSTER,
  ROUTE_PATHS.TRANSPORT_ROSTER,
  ROUTE_PATHS.LESSON_ENTRY,
  ROUTE_PATHS.INSTRUCTOR_ROSTER_LIST
];
